import { render } from "./chatbotPopup.vue?vue&type=template&id=3e146852&scoped=true&ts=true"
import script from "./chatbotPopup.vue?vue&type=script&lang=ts"
export * from "./chatbotPopup.vue?vue&type=script&lang=ts"

import "./chatbotPopup.vue?vue&type=style&index=0&id=3e146852&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e146852"]])

export default __exports__